const listPointsBody = document.querySelector('#newScheduleCellSCardPickerEvent').querySelector('div[name=body]');
import auth from '../tools/storage.js';

import tools from '../tools/tools.js';
export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

    getElement(item, index) {


    let urlImg = '';
    if(item.image)
      urlImg = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/events/${item.image}.jpg`;
    else
      urlImg = 'https://festapp.ru/lk/img/f_bg_main4.jpg';

    return `<div class = "card_event_preview column p-1 " eventID=${item.id}> 
              <img class = "ads_card_preview" style = "max-width:300px;  min-width:300px;   max-height:120px;    width:auto;    height:auto;"  eventID=${item.id}
              src="${urlImg}">
              <div class="w-100 p-1 m-0" eventID=${item.id}>
                <b eventID=${item.id}>${item.name}</b>
              </div>
              
            </div>`;
  },


  drawDataInContainer(enterprisesData, fullArrayData, allFilms) {
    this.cleanContainer();
    let oldSection;

    let fullHtml = '';
 
    if(enterprisesData){
      enterprisesData.forEach((item, index) => {

        fullHtml += this.getElement(item, index);
        // listArbitorsBody.insertAdjacentHTML('beforeend', this.getElement(item, index))
      });
      listPointsBody.innerHTML = fullHtml;
    } else 
      listPointsBody.innerHTML = 'Данных нет!';

  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
